/* eslint-disable require-await */
/* eslint-disable no-undef */
const qs = require('qs')
import vm from '@/main.js'

let defaultParams = {
    client_id: 'app',
    client_secret: 'app'
}

const getToken = (username,password) => {
    return new Promise((resolve, reject) => {
        vm.$http
            .post('api/TokenAuth/Authenticate', {userNameOrEmailAddress: username,password})
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

const getOwnerCredentials = (username, password) => {
    defaultParams.grant_type = 'password'
    defaultParams.username = username
    defaultParams.password = password
    return new Promise((resolve, reject) => {
        vm.$http
            .post('/account/token', qs.stringify(defaultParams), {
              'Content-Type': 'application/x-www-form-urlencoded'
            })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

const getRefreshToken = refreshToken => {
    defaultParams.refresh_token = refreshToken
    defaultParams.grant_type = 'refresh_token'

    return new Promise((resolve, reject) => {
        vm.$http
            .post('/account/token', qs.stringify(defaultParams), {
              'Content-Type': 'application/x-www-form-urlencoded'
            })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                reject(err)
            })
    })
}

export default {
    getToken,
    getOwnerCredentials,
    getRefreshToken
}